
<div class="flex-rounder">

<div class="progress-wrapper">
    <div class="current" [ngStyle]="getOverlayStyle()">
      {{ numberCurrentRdvs }}/{{ numberRdvsMoisPre }}
    </div>
    <app-progress-bar
      [current]="numberCurrentRdvs"
      [max]="numberRdvsMoisPre"
      [color]="gradient ? 'url(#gradient)' : color"
      [background]="background"
      [radius]="radius"
      [stroke]="stroke"
      [semicircle]="semicircle"
      [rounded]="rounded"
      [clockwise]="clockwise"
      [responsive]="responsive"
      [duration]="duration"
      [animation]="animation"
      [animationDelay]="animationDelay"
    ></app-progress-bar>
  </div>

  <span class="projection-rdv">Projection Rdvs</span>
</div>